module.exports = __webpack_public_path__ + "static/media/chat-app.3c87ca3e.png";